import ClipboardJS from 'clipboard';

const copyUrl = () => {
  const copyButton = document.querySelector('.js-copyUrl');
  if (!copyButton) return;

  const clipboard = new ClipboardJS(copyButton);

  clipboard.on('success', () => {
    copyButton.classList.add('is-copied');
  });

  clipboard.on('error', () => {
    copyButton.classList.remove('is-copied');
    alert('URLをコピーできませんでした。');
  });
};

export default copyUrl;
